import Vue from 'vue'
import './icons' // eslint-disable-line import/no-unassigned-import
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import App from './app'
Vue.use(ElementUI);
const app = new Vue({
	el: '#app',
	store,
	render: h => h(App, {ref: 'app'})
})

global.app = app.$refs.app
